import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster, toast } from "sonner";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Features } from "@/components/Features";
import { Changelog } from "@/components/Changelog";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  const notify = (title, description) =>
    toast(title, {
      description,
      style: {
        background: "#132342",
        border: "1px solid rgba(56,189,248,0.3)",
        color: "#F8FAFC",
      },
    });

  return (
    <div id="top" className="min-h-screen bg-[#0A1224] text-slate-50" data-testid="neyrein-app">
      <div className="noise-overlay" />
      <Toaster position="bottom-center" />
      <Navbar onNotify={notify} />
      <main>
        <Hero onNotify={notify} />
        <Marquee />
        <About />
        <Features />
        <Changelog onNotify={notify} />
      </main>
      <Footer onNotify={notify} />
    </div>
  );
}

export default App;
